import React, { useEffect } from 'react';

declare global {
  interface Window {
    jQuery?: any;
  }
}

const SearchResultsForm = () => {
  useEffect(() => {
    const elementToMove = document.querySelector('.text-with-form__wrapper');

    if (elementToMove) {
      const targetContainer = document.querySelector('.search-results__form');

      if (targetContainer && !targetContainer.contains(elementToMove)) {
        targetContainer.appendChild(elementToMove);
        elementToMove.classList.remove('container');
        (elementToMove as HTMLElement).style.display = 'block';

        setTimeout(() => {
          const formId = elementToMove.querySelector('form')?.id?.replace('gform_', '');
          if (formId && window.jQuery) {
            window.jQuery(document).trigger('gform_post_render', [formId, window.jQuery(elementToMove)]);
            window.jQuery(document).trigger('gform_page_loaded', [formId, 1]);
          }
        }, 300);
      }

    }
  }, []);

  return <div className="search-results__form"></div>;
};

export default SearchResultsForm;
